import { create } from 'zustand';

/**
 * 경보 배너 dismiss 상태. 세션 한정 — persist 미적용으로 새로고침/재로그인 시 다시 노출.
 * 의뢰서 P3-2 ROADMAP: "dismiss 가능 (세션 한정)".
 */
interface AlertBannerState {
  dismissed: boolean;
  dismiss: () => void;
  reset: () => void;
}

export const useAlertBannerStore = create<AlertBannerState>((set) => ({
  dismissed: false,
  dismiss: () => set({ dismissed: true }),
  reset: () => set({ dismissed: false }),
}));
